export const onlineAdvantageInfoCard = [
  {
    title: "Kelas online, suasana belajar positif",
    info: [
      {
        bold: {
          number: "1.", // Optional number part
          text: "Membangun motivasi belajar jangka panjang" // The bold text
        },
        normal: [
          "Guru yang menciptakan suasana kelas nyaman bagi murid untuk berpartisipasi",
          "Belajar dengan guru dan teman sama selama 1 semester untuk membangun kenyamanan"
        ]
      },
      {
        bold: {
          number: "2.",
          text: "Membuat murid lebih mudah pahami materi"
        },
        normal: [
          "Pembelajaran terpadu dengan interaksi 2-arah di kelas",
          "Rekrutmen ketat untuk guru dengan penalaran kuat dan pengembangan berkelanjutan"
        ]
      }
    ]
  }
];
